export const permissionLevels = {
  Manager: "Manager",
  NotAvailable: "N/A",
};
